import React from 'react';
import { useTranslation } from 'react-i18next';
import { useVarietyForm } from '../../../features/cropVarieties/hooks/useVarietyForm';
import Card from '../../ui/Card';
import Button from '../../ui/Button';
import LoadingSpinner from '../../ui/LoadingSpinner';

interface Props {
  onSuccess: () => void;
}

const AddVarietyForm: React.FC<Props> = ({ onSuccess }) => {
  const { t } = useTranslation();
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    isValid,
    isSubmitting,
    submitError
  } = useVarietyForm(onSuccess);

  return (
    <Card>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            {t('crops.varieties.name')} *
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={values.name}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
          />
          {errors.name && <p className="mt-1 text-sm text-red-600">{errors.name}</p>}
        </div>

        <div>
          <label htmlFor="description" className="block text-sm font-medium text-gray-700">
            {t('common.description')}
          </label>
          <textarea
            id="description"
            name="description"
            rows={3}
            value={values.description}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
          />
        </div>

        {submitError && (
          <p className="text-sm text-red-600">{submitError}</p>
        )}

        <div className="flex justify-end space-x-3">
          <Button
            type="button"
            variant="secondary"
            onClick={onSuccess}
            disabled={isSubmitting}
          >
            {t('common.cancel')}
          </Button>
          <Button
            type="submit"
            disabled={!isValid || isSubmitting}
          >
            {isSubmitting ? <LoadingSpinner size="sm" /> : t('common.save')}
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default AddVarietyForm;